import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Companies() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/hris/registration-refs").then(({ data }) => setRows(data.companies || [])).catch(() => {});
  }, []);

  return (
    <div className="uemp-fade-in">
      <PageHeader title="Companies" subtitle="Company registry — maintained centrally in Master Settings → Companies." />

      <div className="rounded-lg border border-blue-100 bg-blue-50/60 px-4 py-3 mb-4 flex items-center gap-2 text-sm text-blue-700" data-testid="companies-notice">
        <Icons.Info className="h-4 w-4 shrink-0" />
        This list reflects the central company registry. To add or edit companies, go to Master Settings → Companies.
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-slate-50"><TableHead>Company</TableHead><TableHead className="w-40">Code</TableHead></TableRow></TableHeader>
          <TableBody data-testid="companies-table">
            {rows.length === 0 && <TableRow><TableCell colSpan={2} className="text-center text-slate-400 py-8">No companies registered.</TableCell></TableRow>}
            {rows.map((c) => (
              <TableRow key={c.id} data-testid="companies-row">
                <TableCell className="text-sm font-medium text-slate-800">{c.name}</TableCell>
                <TableCell className="text-sm text-slate-500">{c.code || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
